module.exports = __webpack_public_path__ + "img/apple.d605e945.svg";